import Config from '../../Config'
import { TOKEN_KEY } from '../../auth/Auth'

export const getProviders = (data, PageNumber, ItemsPerPage) => {
  return new Promise((resolve, reject) => {
    const url = `${Config.providers.searchApiUrl}?PageNumber=${PageNumber}&ItemsPerPage=${ItemsPerPage}`
    const bodyData = {
      address: data.filters.address,
      coordinates: {
        latitude: data.lat,
        longitude: data.lng
      },
      distance: data.filters.radius !== 0 ? data.filters.radius : 1000,
      providerServiceType: data.filters.providerType !== '' ? data.filters.providerType : null,
      providerSpecialty: data.filters.providerTypeSubcategory !== '' ? data.filters.providerTypeSubcategory : null
    }
    fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem(TOKEN_KEY),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => resolve(data))
      .catch(error => reject(error))
  })
}

export const getSpecialities = (language = 'en-CA') => {
  return new Promise((resolve, reject) => {
    const url = `${Config.providers.specialitiesApiUrl}`
    fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem(TOKEN_KEY),
        'Accept-Language': language,
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => resolve(data))
      .catch(error => reject(error))
  })
}



// WEBPACK FOOTER //
// ./src/redux/actions/providersActions.js